import { axiosAuth as Api } from "../utils/axios";
import CONFIG from "../utils/config";

const defaultTime = 5000;
const userEnpoint = CONFIG.PROD_API_BASE_URL+ CONFIG.VUE_APP_SERVICE_USER_PRIVATE
const userEnpointPublic = CONFIG.PROD_API_BASE_URL+ CONFIG.VUE_APP_SERVICE_USER
const userOldEndpoint = CONFIG.PROD_API_BASE_URL+ CONFIG.VUE_APP_SERVICE_USER_OLD

export const authApi = Object.freeze({
    login: payload => {
        const res = Api.post(`/token`, payload, {
            headers: { "Content-Type": "application/x-www-form-urlencoded;charset=utf-8" },
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },

    getNewToken: payload =>
        Api.post("/token", payload, {
            headers: { "Content-Type": "application/x-www-form-urlencoded;charset=utf-8" },
            timeout: defaultTime
    }),

    getMe: (token) => {
        const res = Api.get(userEnpoint + '/me', { headers: { Authorization: `Bearer ${token}` } })
        return Promise.resolve(res)
    },
        
    checkOldData(payload) {
        try {
            const res = Api.post(userOldEndpoint, payload)
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    },

    register(payload) {
        try {
            const res = Api.post(userEnpointPublic + '/user', payload, {
                headers: { 
                    'Content-Type': 'application/json',
                }
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    }
});
